module.exports = __webpack_public_path__ + "media/images/cardboard-bg-05-afa4266abe0eba8e3f8cc1285a2a2fd2.png";